<template>
  <v-app class="grey lighten-4">
    <MessageBar></MessageBar>
    <Navbar />
    <AuthWrapper>
      <v-content>
        <router-view></router-view>
      </v-content>
    </AuthWrapper>
  </v-app>
</template>

<script>
import Navbar from "@/components/Navbar";
import AuthWrapper from "@/components/AuthWrapper";
import Store from "@/services/store";
import { mapActions } from "vuex";
import MessageBar from "@/components/utilities/MessageBar";

export default {
  name: "App",
  components: {
    AuthWrapper,
    Navbar,
    MessageBar
  },
  created() {
    const title = process.env.VUE_APP_TITLE;
    if (title) {
      document.title = title;
    }
    Store.commit("site/denied", false);
  },
  mounted: function() {
    this.resetWatch();
  },
  methods: {
    ...mapActions("site", ["resetWatch"])
  }
};
</script>
